document.addEventListener("DOMContentLoaded", () => {
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  if (!mobileMenu) return;

  const mobileMenuButton = document.querySelector("[data-hamburger-button]");
  const mobileCloseMenuButton = document.querySelector("[data-close-button]");
  const mobileNavMenuItems = mobileMenu.querySelectorAll(".navbar__menu .menu-item-has-children > a");
  const mobileNavBackButtons = mobileMenu.querySelectorAll(".navbar__menu .menu-item-type-back > a");

  const toggleAttribute = (element, attribute, condition) => {
    element.toggleAttribute(attribute, condition);
  };

  const toggleMenu = (open) => {
    toggleAttribute(mobileMenu, "data-open", open);
    toggleAttribute(document.body, "tabindex", open ? "-1" : null);
    document.body.classList.toggle("overflow-hidden");

    if (!open) {
      mobileNavMenuItems.forEach((itemLink) => {
        const item = itemLink.closest(".menu-item-has-children");
        const subMenu = item.querySelector(":scope > .sub-menu");
        item.removeAttribute("data-expanded");
        if (subMenu) {
          toggleAttribute(subMenu, "data-open", false);
        }
      });
    }
  };

  const toggleMenuItem = (itemLink) => {
    const menu = itemLink.closest(".navbar__menu, .sub-menu");
    const item = itemLink.closest(".menu-item-has-children");
    const subMenu = item.querySelector(":scope > .sub-menu");
    if (subMenu) {
      const isOpen = subMenu.dataset.open;

      if (!isOpen) {
        menu.querySelectorAll(".menu-item-has-children > .sub-menu").forEach((otherItemLink) => {
          const otherItem = otherItemLink.closest(".menu-item-has-children");
          const subMenu = otherItem.querySelector(".sub-menu");
          otherItem.removeAttribute("data-expanded");
          if (subMenu) {
            toggleAttribute(subMenu, "data-open", false);
          }
        });

        item.setAttribute("data-expanded", true);
        subMenu.setAttribute("data-open", true);
      } else {
        item.removeAttribute("data-expanded");
        subMenu.removeAttribute("data-open");
      }
    }
  };

  mobileNavMenuItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      toggleMenuItem(item);
    });
  });

  [mobileMenuButton, mobileCloseMenuButton].forEach((button, index) => {
    button.addEventListener("click", () => {
      if (index === 0) {
        const isOpen = mobileMenu.hasAttribute("data-open");
        toggleMenu(!isOpen);
      } else {
        mobileNavMenuItems.forEach((itemLink) => {
          const otherItem = itemLink.closest(".menu-item-has-children");
          otherItem.classList.remove("open");
        });
        toggleMenu(false);
      }
    });
  });

  mobileNavBackButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const subMenu = button.closest(".sub-menu");
      if (subMenu) {
        subMenu.removeAttribute("data-open");
        subMenu.closest(".menu-item-has-children").removeAttribute("data-expanded");
      }
    });
  });
});
